import React from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import "react-lazy-load-image-component/src/effects/blur.css";

const LazyLoadImageComponent = (props) => {
    const { width, height, imageSrc, placeholderImageSrc, alt, style = {}, className = "", onError } = props;
    return (
        <LazyLoadImage
            alt={alt}
            height={height}
            src={imageSrc} // use normal <img> attributes as props
            width={width}
            effect="blur"
            style={style}
            className={className}
            placeholderSrc={placeholderImageSrc}
            onError={(e) => onError ? onError(e) : null}
        // wrapperProps={{
        //     // If you need to, you can tweak the effect transition using the wrapper style.
        //     style: {transitionDelay: "1s"},
        // }}
        />
    )
}

export default LazyLoadImageComponent;